import { Button, mergeClasses } from '@fluentui/react-components';
import { ArrowDownRegular, ArrowUpRegular } from '@fluentui/react-icons';
import type { ComponentProps } from 'react';
import { DayPicker } from 'react-day-picker';
import { useStyles } from './styles.js';

export type DateRangeCalendarProps = ComponentProps<typeof DayPicker>;

export function Calendar({
    className,
    classNames,
    components,
    formatters,
    showOutsideDays = true,
    ...props
}: DateRangeCalendarProps) {
    const styles = useStyles();

    return (
        <DayPicker
            showOutsideDays={showOutsideDays}
            className={mergeClasses(styles.root, className)}
            classNames={{
                root: styles.root,

                months: styles.months,
                month: styles.month,

                caption_label: styles.caption_label,

                nav: styles.nav,
                button_previous: styles.button_previous,
                button_next: styles.button_next,

                month_grid: styles.month_grid,

                weekdays: styles.weekdays,
                weekday: styles.weekday,

                weeks: styles.weeks,
                week: styles.week,
                day: styles.day,

                day_button: styles.day_button,
                selected: styles.selected,
                range_start: styles.range_start,
                range_end: styles.range_end,
                range_middle: styles.range_middle,
                today: styles.today,

                outside: styles.outside,
                disabled: styles.disabled,
                hidden: styles.hidden,

                // add user configured classNames
                ...classNames,
            }}
            components={{
                PreviousMonthButton: ({ className, onClick }) => (
                    <Button className={className} appearance="subtle" icon={<ArrowUpRegular />} onClick={onClick} />
                ),
                NextMonthButton: ({ className, onClick }) => (
                    <Button className={className} appearance="subtle" icon={<ArrowDownRegular />} onClick={onClick} />
                ),

                // add user configured components
                ...components,
            }}
            formatters={{
                formatWeekdayName: (date) =>
                    date.toLocaleDateString('de', {
                        weekday: 'narrow',
                    }),

                // add user configured formatters
                ...formatters,
            }}
            {...props}
        />
    );
}
